export default {
  zones_list: (state) => state.zones_list,
  zones: (state) => state.zones,
  location_areas_list: (state) => state.location_areas_list,
  location_areas: (state) => state.location_areas,
  micro_fulfillment_list: (state) => state.micro_fulfillment_list,
  micro_fulfillment_centers: (state) => state.micro_fulfillment_centers,
};
